import { render, staticRenderFns } from "./confirmEmail.popup-chunk.vue?vue&type=template&id=0497911e&scoped=true"
import script from "./confirmEmail.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmEmail.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./confirmEmail.popup-chunk.vue?vue&type=style&index=0&id=0497911e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497911e",
  null
  
)

export default component.exports